export default function isValidNumber(num) {
  const parsedNum = parseInt(num)
  return (
    (typeof num === 'number' ||
      (typeof num === 'string' && !Number.isNaN(parsedNum))) &&
    Number.isFinite(parsedNum)
  )
}
